import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-text-area',
  imports: [
    FormsModule
  ],
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.css'
})
export class TextAreaComponent {
  public maxLetterCount: number = 500;
  @Input()
  value: string | null = null;

  @Output()
  valueChange = new EventEmitter<string>();

  @Input()
  placeholder: string | null = null;

  @Input()
  showError: boolean = false;

  @Input()
  required: boolean = false;

  hasError() {
    return (this.showError && this.required) ? !this.value : false
  }

  onValueChanged($event: string) {
    if ($event.length > this.maxLetterCount) {
      this.value = $event.substring(0, this.maxLetterCount);
    }
    this.valueChange.emit($event)
  }
}
